/**
 * @fileoverview Google Maps API Loader Component
 *
 * Loads the Google Maps Places API dynamically using environment variable.
 * The API key is stored in .env.local and never committed to git.
 */

import { useEffect } from 'react';

/**
 * Component to load Google Maps Places API
 *
 * This component doesn't render anything, it just loads the script
 * when mounted.
 */
const GoogleMapsLoader = () => {
  useEffect(() => {
    // Check if already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      return;
    }

    // Get API key from environment variable
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    // If no API key, features will use fallback mode (curated city lists)
    if (!apiKey) {
      console.info('Google Places API key not configured. Using fallback mode for address/city autocomplete.');
      console.info('To enable full autocomplete:');
      console.info('1. Create .env.local file in client/ folder');
      console.info('2. Add: REACT_APP_GOOGLE_MAPS_API_KEY=your_api_key_here');
      console.info('3. Get API key at: https://console.cloud.google.com/');
      return;
    }

    // Load Google Maps JavaScript API with Places library
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      // 
    };

    script.onerror = () => {
      console.error('Failed to load Google Places API. Check your API key and network connection.');
    };

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Note: We don't remove the script on unmount as it should persist
      // across the entire app lifetime
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default GoogleMapsLoader;
